export default "__VITE_ASSET__d875ff04__"